<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="12">
            <h4>
              Quản lý uSim <a v-b-tooltip.hover.top="'Lấy lại danh sách!'" class="btn-icon"
                              @click="$router.go()">
              <feather-icon icon="RepeatIcon"/>
            </a>
              <span class="float-right">
                                <b-input-group>
                                    <b-form-input v-model="searchString" placeholder="Tìm kiếm nhanh" size="sm"
                                                  @keypress.enter="quickSearch"/>
                                    <b-input-group-append is-text role="button" @click="quickSearch">
                                        <feather-icon icon="SearchIcon"/>
                                    </b-input-group-append>
                                </b-input-group>
                                <div>
                                    <b-button v-if="userData && userData.user_level == 1" class="mt-1 mr-1" size="md"
                                              variant="primary"
                                              @click="onShowModalChangeImport()">
                                        Import sim mới
                                    </b-button>
                                    <b-button class="mt-1" size="md" variant="primary" @click="onShowModalChange()">
                                        Điều chuyển theo dải
                                    </b-button>
                                </div>
                            </span>
            </h4>
          </b-col>
          <!-- <b-col cols="12">
<b-tabs>
  <b-tab active @click="changeTab(null)" title="Tất cả đơn hàng">
  </b-tab>
  <b-tab
    @click="changeTab(1)" title="Chờ xác nhận"
  >
  </b-tab>
  <b-tab
    @click="changeTab(2)" title="Đã xác nhận"
  >
  </b-tab>
  <b-tab
    @click="changeTab(3)" title="Hoàn tất"
  >
  </b-tab>
  <b-tab
    @click="changeTab(90)" title="Đơn hàng lỗi"
  >
  </b-tab>
  <b-tab
    @click="changeTab(91)" title="Trả hàng"
  >
  </b-tab>
</b-tabs>
</b-col> -->
          <!-- Per Page -->
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="fields" :isLoading.sync="isLoading" :line-numbers="true"
                            :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [10, 20, 50, 100], dropdownAllowAll: false }"
                            :rows="rows" :totalRows="totalRecords" mode="remote"
                            @on-page-change="onPageChange" @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange">
              <template slot="column-filter" slot-scope="{column, updateFilters}">
                                <span v-if="column.field === 'StoreID'" class="position-relative">
                                    <Select2 v-model="filterValue.storeId"
                                             :options="storeList.map(item => ({ id: item.Id, text: item.Name }))"
                                             @change="updateFilters(column, filterValue.storeId)"/>
                                    <span v-if="filterValue.storeId" class="clear-button"
                                          @click="filterValue.storeId = '', updateFilters(column, filterValue.storeId)">X</span>
                                </span>
                <span v-else-if="column.field === 'Status'" class="position-relative">
                                    <Select2 v-model="filterValue.statusId" :options="statusList"
                                             @change="updateFilters(column, filterValue.statusId)"/>
                                    <span v-if="filterValue.statusId" class="clear-button"
                                          @click="filterValue.statusId = '', updateFilters(column, filterValue.statusId)">X</span>
                                </span>
              </template>
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                                    <span>

                                        <b-button class="btn-icon" size="sm" variant="primary"
                                                  @click="onOpenChangeStatusModal(props.row)">
                                            <feather-icon icon="Edit2Icon"/>
                                        </b-button>
                                        <b-button class="btn-icon" size="sm" style="margin-left:6px" variant="primary"
                                                  @click="onOpenChangeStoreModal(props.row)">
                                            <feather-icon icon="RepeatIcon"/>
                                        </b-button>
                                    </span>
                                </span>

                <span v-else-if="props.column.field === 'DeliveryType'">
                                    <feather-icon v-if="props.row.DeliveryType == 1" icon="CheckIcon"/>
                                </span>
                <span v-else-if="props.column.field === 'IsEsim'">
                                {{
                                    props.row.IsEsim===1?"ESIM":"USIM"
                                  }}
                            </span>
                <span v-else-if="props.column.field === 'TotalPrice'">
                                    {{ props.formattedRow[props.column.field] | number }}
                                </span>
                <span v-else-if="props.column.field === 'Phones'">
                                    <span v-html="props.row.Phones.replace(/,/g, '<br>')"/>
                                </span>
                <span v-else-if="props.column.field === 'CreateDate'">
                                    {{ dateNewFormat(props.row[props.column.field]) }}
                                </span>
                <span v-else-if="props.column.field === 'StoreID'">
                                    {{
                    storeList.find(item => item.Id == props.row[props.column.field]) ?
                        storeList.find(item => item.Id == props.row[props.column.field]).Name :
                        props.row[props.column.field]
                  }}
                                </span>
                <span v-else-if="props.column.field === 'Id'">
                                    <a class="text-primary" @click="view(props.index)">{{ props.row.Id }}</a>
                                </span>
                <span v-else-if="props.column.field === 'GHTK_Id'">
                                    <a :href="'https://i.ghtk.vn/' + props.row.GHTK_Id" target="_blank">{{
                                        props.row.GHTK_Id
                                      }}</a>
                                </span>
                <span v-else-if="props.column.field === 'Status'">
                                    <span class="badge badge-light-info">{{
                                        statusList.find(m => m.id ==
                                            props.row.Status).text
                                      }}</span>
                                </span>
                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>

              </template>
            </vue-good-table>
          </b-col>

        </b-row>
      </div>
    </b-card>
    <b-modal id="modal-change-status" :title="'Cập nhật trạng thái'" @ok="onChangeStatus">
      <validation-observer ref="modalView">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Serial">
              <b-form-input v-model="currentItem.Serial" disabled size="sm"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Trạng thái">
              <Select2 v-model="currentItem.newStatus" :options="statusList"/>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-change-store" :title="'Điều chuyển sim'" @ok="onChangeStore">
      <validation-observer ref="modalView">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Serial">
              <b-form-input v-model="currentItem.Serial" disabled size="sm"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Kho">
              <Select2 v-model="currentItem.newStoreID"
                       :options="storeToList.map(item => ({ id: item.Id, text: item.Name }))"/>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-change" :size="action == 1 ? 'md' : 'xl'"
             :title="action == 1 ? 'Import sim mới' : 'Điều chuyển'" ignore-enforce-focus-selector=".select2-search__field"
             @ok="onChangeStoreByFile" @open="onModalImportTransferOpen">
      <validation-observer ref="modalView">
        <b-row v-if="action != 1">
          <h4 class="pt-2 pl-1">Đơn vị cấp trên</h4>
        </b-row>
        <div class="border rounded bg-white p-1 pt-2-5">
          <b-row>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group label="Kho">
                  <Select2 v-model="fromStoreID" :disabled="true"
                           :options="storeList.map(item => ({ id: item.Id, text: item.Name }))"
                           @change="onModalImportTransferStoreSelectChange"/>
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Vui lòng chọn kho</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group label="Sản phẩm">
                  <Select2 v-model="product" :options="[{ id: 'usim', text: 'Usim' }]"/>
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Vui lòng chọn sản phẩm</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="action == 1">
            <b-col class="mt-1" cols="12">
              <b-form-group>
                <b-form-radio-group id="btn-radios-2" v-model="selectedSerialInputType"
                                    :options="action == 1 ? optionsSerialInputType : optionsSerialInputTypeTransfer"
                                    button-variant="outline-primary" buttons
                                    name="radio-btn-outline" size="sm"></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="action == 1 && selectedSerialInputType == 1">
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group label="Từ số">
                  <b-form-input v-model="fromSerial" type="number"/>
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Vui lòng nhâp số serial bắt đầu từ</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="action == 1 && selectedSerialInputType == 1">
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group label="Đến số">
                  <b-form-input v-model="toSerial" type="number"/>
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Vui lòng nhâp số serial kết thúc</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="action == 1 && selectedSerialInputType == 2">
            <b-col class="center-cls" cols="12">
              <div>
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group>

                    <label for="uploadCSVFile">
                      <div class="sample-file__download">
                        <feather-icon icon="UploadIcon" style="margin-right: 8px;"/>
                        Upload file
                      </div>
                    </label>
                    <div v-if="file && file.name">
                      {{ file.name }}
                    </div>
                    <b-form-file id="uploadCSVFile" v-model="file" accept=".xls,.xlsx" hidden plain></b-form-file>
                    <div class="error-txt">
                      <small v-if="errors.length > 0">Vui lòng chọn file</small>
                    </div>
                  </b-form-group>
                </validation-provider>
                <a href="/fileExcel/up.xlsx">
                  <div class="sample-file__download">
                    <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                    Tải file mẫu
                  </div>
                </a>
              </div>
            </b-col>
          </b-row>
          <!-- Chon sim tu kho -->
          <b-row v-if="action == 2">
            <b-col cols="12">
              <legend class="bv-no-focus-ring col-form-label pt-0">Chọn sim từ kho</legend>
              <table class="c-table">
                <thead>
                <tr>
                  <th rowspan="2">STT</th>
                  <th colspan="3">Kho</th>
                  <th colspan="3">Chọn sim</th>
                  <th rowspan="2"></th>
                </tr>
                <tr>
                  <th>Từ số</th>
                  <th>Đến số</th>
                  <th>Số lượng</th>
                  <th>Từ số</th>
                  <th>Đến số</th>
                  <th>Số lượng</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, idx) in tableSelectSim.rows" :key="idx">
                  <td>{{ idx + 1 }}</td>
                  <td>{{ row.storeFromSerial }}</td>
                  <td>{{ row.storeToSerial }}</td>
                  <td width="70">{{ row.storeQuantity }}</td>
                  <td>
                    <div class="c-form-group">
                      <b-form-input v-model="row.selectFromSerial" :class="{ invalid: !row.selectFromSerialValid }" :disabled="!row.checked"
                                    size="sm"
                                    type="number" @input="onTableSelectFromInputChange(row, $event)"/>
                      <div v-if="!row.selectFromSerialValid" class="error-ico">
                        <feather-icon icon="AlertCircleIcon"/>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="c-form-group">
                      <b-form-input v-model="row.selectToSerial" :class="{ invalid: !row.selectToSerialValid }" :disabled="!row.checked"
                                    size="sm"
                                    type="number" @input="onTableSelectToInputChange(row, $event)"/>
                      <div v-if="!row.selectToSerialValid" class="error-ico">
                        <feather-icon icon="AlertCircleIcon"/>
                      </div>
                    </div>
                  </td>
                  <td width="70">
                    <div class="c-form-group">
                      <b-form-input v-model="row.selectQuantity" :class="{ invalid: !row.selectQuantityValid }" :disabled="!row.checked"
                                    size="sm"
                                    type="number" @input="onTableSelectQuantityInputChange(row, $event)"/>
                      <div v-if="!row.selectQuantityValid" class="error-ico">
                        <feather-icon icon="AlertCircleIcon"/>
                      </div>
                    </div>
                  </td>
                  <td>
                    <b-form-checkbox v-model="row.checked" class="ml-2" @change="onCheckSim($event, row, idx)"/>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <!-- End cho sim tu kho -->
        </div>

        <b-row v-if="action == 2">
          <h4 class="pt-2 pl-1">Đơn vị cấp dưới</h4>
        </b-row>
        <div v-if="action == 2" class="border rounded bg-white p-1 pt-2-5">
          <b-row>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group label="Kho">
                  <Select2 v-model="toStoreID"
                           :options="storeToList.filter(el => el.Id != fromStoreID).map(item => ({ id: item.Id, text: item.Name }))"/>
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Vui lòng chọn kho</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </div>

      </validation-observer>
    </b-modal>
    <b-modal id="modal-change-error" :title="'Bạn có muốn nhập các bản không bị lỗi'"
             @ok="runImportTransferAPI">
      <validation-observer ref="modalView1">
        <b-row>
          <h4 class="pt-2 pl-1">Danh sách sim bị lỗi</h4>
        </b-row>
        <b-row class="d-flex justify-content-center">
          <vue-good-table :columns="fieldsError" :line-numbers="true" :pagination-options="{ enabled: true }"
                          :rows="listErrorSim" mode="remote">
            <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'Status'">
                                <span class="badge badge-light-info">{{
                                    ListStatus.find(m => m.id ==
                                        props.row.Status).text
                                  }}</span>
                            </span>
            </template>
          </vue-good-table>
        </b-row>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import moment from 'moment';
import SearchSelect from "../components/select/SearchSelect.vue";
import bigInt from "big-integer"
import {getUserData} from "@/auth/utils"
import * as XLSX from 'xlsx';

export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect,
    BFormFile,
    BFormRadioGroup
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    this.loadMasterData();
  },
  computed: {
    userData() {
      return getUserData() || null
    },
  },
  watch: {
    $route(to, from) {
      this.loadMasterData();
    }
  },
  methods: {
    /*viewDKTTHist(p){
      console.log(p);
      this.dkttRows = p.reg_hist;
      this.$bvModal.show('modal-dktt');
    },*/
    createShipment1() {
      if (confirm("Chỉ tạo vận đơn mới khi vận đơn cũ không tạo lại được!")) {
        this.loading(true);
        useJwt.get('ghtk/create-order-force/' + this.currentItem.Id).then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {title: response.data.result.message, icon: 'AlertTriangleIcon', variant: 'info'}
          })
          console.log(response.data.result);
          this.loading(false);
        }).catch(error => {
          if (error.response.data.code == 403) {
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
            })
          }
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result.message, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
          this.loading(false);
        })
      }
    },
    createShipment() {
      this.loading(true);
      useJwt.get('ghtk/create-order/' + this.currentItem.Id).then(response => {
        this.$toast({
          component: ToastificationContent,
          props: {title: response.data.result.message, icon: 'AlertTriangleIcon', variant: 'info'}
        })
        console.log(response.data.result);
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.$toast({
          component: ToastificationContent,
          props: {title: error.response.data.result.message, icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        this.loading(false);
      })
    },
    updatePhoneAndMail() {
      if (!this.isEditPhoneEmail) {
        this.isEditPhoneEmail = true;
        return;
      }

      this.loading(true);
      const data = {
        ContactPhone: this.currentItem.ContactPhone,
        Email: this.currentItem.Email,
        OrderId: this.currentItem.Id,
        Addr: this.currentItem.Addr,
        CityId: this.currentItem.CityId,
        DistrictId: this.currentItem.DistrictId,
        WardId: this.currentItem.WardId,
      }

      useJwt.put('update-order-info/' + this.currentItem.Id, data).then(response => {
        this.$toast({
          component: ToastificationContent,
          props: {title: response.data.message, icon: 'AlertTriangleIcon', variant: 'info'}
        });
        this.isEditPhoneEmail = false;
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.isEditPhoneEmail = false;
        this.loading(false);
      })
    },
    reActive(msisdn, msin) {
      this.loading(true);
      useJwt.post('sps/createSub2', {orderId: this.currentItem.Id, msisdn: msisdn, msin: msin}).then(response => {
        console.log(response.data.result);
        this.$toast({
          component: ToastificationContent,
          props: {title: response.data.result.createSub, icon: 'AlertTriangleIcon', variant: 'info'}
        })
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    rePrint(msisdn, msin) {
      this.loading(true);
      useJwt.post('sps/printSub', {orderId: this.currentItem.Id, msisdn: msisdn, msin: msin}).then(response => {
        console.log(response.data.result);
        this.$toast({
          component: ToastificationContent,
          props: {title: response.data.result.createSub, icon: 'AlertTriangleIcon', variant: 'info'}
        })
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    esimEmail(msisdn) {
      this.loading(true);
      useJwt.get('send-mail-esim/' + this.currentItem.Id + "/" + msisdn).then(response => {
        console.log(response.data.result);
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Kết quả: ' + response.data.result, icon: 'AlertTriangleIcon', variant: 'info'}
        })
        this.loading(false);
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    dateNewFormat(v) {
      return moment(v, 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY hh:mm:ss')
    },
    changeTab(i) {
      this.serverParams.columnFilters.searchString = null;
      this.serverParams.columnFilters.status = i;
      this.loadItems();
    },
    quickSearch() {
      this.serverParams.columnFilters.status = null;
      this.serverParams.columnFilters.searchString = this.searchString;
      this.loadItems();
    },
    loadMasterData() {
      this.loadItems()
      this.loadStores()
      this.loadStoreTo()
      this.fetchCities()
      this.loadSimFromStore()
    },
    loadStores() {
      useJwt.get('usim/store').then(response => {
        if (+response.data.code == 200) {
          this.storeList = response.data.result;
        } else {
          this.storeList = []
        }
      }).catch(error => {
        this.storeList = []
      })
    },
    loadStoreTo() {
      useJwt.get('usim/store/1').then(response => {
        if (+response.data.code == 200) {
          this.storeToList = response.data.result;
        } else {
          this.storeToList = []
        }
      }).catch(error => {
        this.storeToList = []
      })
    },
    async loadSimFromStore() {
      const rs = await this.getUsimByQuantity(0)
      this.$set(this.tableSelectSim, 'rows', rs.map((row, idx) => ({
        stt: idx,
        storeFromSerial: row.FromSerial,
        storeToSerial: row.ToSerial,
        storeQuantity: row.Count,
        selectFromSerial: null,
        selectFromSerialValid: true,
        selectToSerial: null,
        selectToSerialValid: true,
        selectQuantity: null,
        selectQuantityValid: true,
        checked: false
      })))
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    loadItems() {
      this.loading(true);
      this.isLoading = true;
      useJwt.post('usim/search', this.serverParams).then(response => {
        this.rows = response.data.result;
        this.statusList = response.data.extra.Status
        this.totalRecords = response.data.totalRecords;
        this.isLoading = false;
        this.loading(false);
      }).catch(error => {
        this.loading(false);
        this.isLoading = false;
      })
    },
    // viewChangetstaus(idx){
    //   this.currentItem.newStatus = this.currentItem.Status;
    //   this.isLoading=true;
    //   this.currentItem = this.rows[idx];
    //   this.$bvModal.show('modal-change-status');
    //   this.isLoading=false;
    // },
    // handleChangeStatus(bvModalEvt){
    //   bvModalEvt.preventDefault()
    //   useJwt.put('order/'+this.currentItem.Id+'/'+this.currentItem.newStatus,{notes:this.currentItem.notes}).then(response =>{
    //     this.loadItems();
    //     this.loading(false);
    //     this.$bvModal.hide('modal-change-status');
    //   }).catch(error => {
    //     if (error.response.data.code==403){
    //       this.$toast({component: ToastificationContent,props: {title: 'Không có quyền thao tác nghiệp vụ này!',icon: 'AlertTriangleIcon',variant: 'warning'}})
    //     }else{
    //       this.$toast({component: ToastificationContent,props: {title: error.response.data.result,icon: 'AlertTriangleIcon',variant: 'warning'}})
    //     }
    //     this.loading(false);
    //   })
    // },
    view(idx) {
      //   this.isLoading=true;
      //   this.currentItem = this.rows[idx];
      //   try{
      //     if (this.currentItem.J_VnPay!=null){
      //       this.currentItem.J_VnPay = JSON.parse(this.currentItem.J_VnPay);
      //     }
      //     if (this.currentItem.J_Shipment_Tracking!=null){
      //       this.currentItem.J_Shipment_Tracking = JSON.parse(this.currentItem.J_Shipment_Tracking);
      //     }
      //   }catch(e){}
      //   if (this.currentItem.J_VnPay && this.currentItem.J_VnPay.vnp_ResponseCode){
      //     var x = this.vnPayErrors.find(m=>m.id==this.currentItem.J_VnPay.vnp_ResponseCode);
      //     if (x!=undefined){
      //       this.currentItem.J_VnPay.vnp_Status = x.text
      //     }else{
      //       this.currentItem.J_VnPay.vnp_Status = 'Trạng thái không xác định - '+this.currentItem.J_VnPay.vnp_ResponseCode
      //     }

      //   }
      //   this.loading(true);
      //   if(this.currentItem.CityId){
      //     this.fetchDistricts(false, false)
      //     this.fetchWards(false, false)
      //   }
      //   useJwt.get('order-detail/'+this.currentItem.Id).then(response =>{
      //     this.currentItem.ListPhones = response.data.result.phones;
      //     this.currentItem.steps = response.data.result.steps.filter(m=>m.LogType=='Order-Status');
      //     this.currentItem.logs = response.data.result.steps
      //     this.currentItem.notify = response.data.result.notify;
      //     this.currentItem.dktts = response.data.result.dktts;
      //     this.statusList.forEach(m=>m.has=false);
      //     this.currentItem.steps.forEach(i=>{
      //       var s = this.statusList.find(m=>m.id==i.Content);
      //       if (s!=undefined){
      //         s.has=true;
      //       }
      //     })
      //     var s1 = this.statusList.find(m=>m.id==this.currentItem.Status);
      //     if (s1!=undefined){
      //       s1.has=true;
      //     }
      //     //console.log(this.currentItem);
      //     //console.log(this.statusList.find(m=>m.id==this.currentItem.Status));
      //     this.currentItem = JSON.parse(JSON.stringify(this.currentItem))
      //     this.loading(false);
      //     this.$bvModal.show('modal-view');
      //     this.isLoading=false;
      //   }).catch(error => {
      //     this.loading(false);
      //     this.isLoading=false;
      //   })
    },
    async handleOk(bvModalEvt) {

    },
    handleHide() {
      this.loadItems();
      this.isEditPhoneEmail = false;
    },
    async fetchCities() {
      try {
        const res = await useJwt.post("getMasterData/GHTK_City", {
          columnFilters: {},
          sort: [],
          page: 1,
          pageSize: 1000
        });

        this.Cities = res.data.result.map((item) => {
          return {
            value: item.Id,
            text: item.Name,
          };
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Có lỗi trong quá trình lấy dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
      }
    },
    async fetchDistricts(isCityChange = false, showLoading = true) {
      if (isCityChange) {
        this.currentItem.DistrictId = 0;
        this.currentItem.WardId = 0;
      }

      if (this.currentItem.CityId > 0) {
        if (showLoading) {
          this.loading(true);
        }
        useJwt.post("getMasterData/GHTK_District", {
          columnFilters: {CityId: this.currentItem.CityId},
          sort: [],
          page: 1,
          pageSize: 1000,
        })
            .then((response) => {
              this.Districts = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchWards(isDistrictChange = false, showLoading = true) {
      if (isDistrictChange) {
        this.currentItem.WardId = 0;
      }

      if (this.currentItem.DistrictId > 0) {
        if (showLoading) {
          this.loading(true);
        }

        useJwt.post("getMasterData/GHTK_Ward", {
          columnFilters: {DistrictId: this.currentItem.DistrictId},
          sort: [],
          page: 1,
          pageSize: 1000,
          lang: this.$l,
        })
            .then((response) => {
              this.Wards = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    onOpenChangeStatusModal(row) {
      this.isLoading = true;
      this.currentItem = row;
      this.currentItem.newStatus = row.Status;
      this.$bvModal.show('modal-change-status');
      this.isLoading = false;
    },
    onOpenChangeStoreModal(row) {
      this.isLoading = true;
      this.currentItem = row;
      this.currentItem.newStoreID = row.StoreID;
      this.$bvModal.show('modal-change-store');
      this.isLoading = false;
    },
    onChangeStatus(bvModalEvt) {
      bvModalEvt.preventDefault()

      const updateData = {
        "id": this.currentItem.ID,
        "toStoreID": null,
        "status": this.currentItem.newStatus
      }

      useJwt.put('usim', updateData).then(response => {
        if (response.data.code == 400) {
          this.$toast({
            component: ToastificationContent,
            props: {title: response.data.message, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
          this.loading(false);
          return;
        }
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Cập nhật thành công!', icon: 'CheckSquareIcon', variant: 'success'}
        })
        this.loadItems();
        this.loading(false);
        this.$bvModal.hide('modal-change-status');
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    onChangeStore(bvModalEvt) {
      bvModalEvt.preventDefault()

      const updateData = {
        "id": this.currentItem.ID,
        "toStoreID": this.currentItem.newStoreID,
        "status": null
      }

      useJwt.put('usim', updateData).then(response => {
        if (response.data.code == 400) {
          this.$toast({
            component: ToastificationContent,
            props: {title: response.data.message, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
          this.loading(false);
          return;
        }
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Cập nhật thành công!', icon: 'CheckSquareIcon', variant: 'success'}
        })
        this.loadItems();
        this.loading(false);
        this.$bvModal.hide('modal-change-store');
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    readFile(input) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, {
            type: 'array',
            cellDates: true,
            cellNF: false,
            cellText: false
          });

          // Get first sheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: ['STT','serial', 'productName', 'isEsim', 'qrCode'],
            range: 1 // Skip header row
          });

          // Transform data to match required format
          const formattedData = jsonData.map(row => ({
            serial: row.serial ? row.serial.toString() : '',
            isEsim: row.isEsim || 0,
            productName: row.productName || '',
            qrCode: row.qrCode || ''
          })).filter(row => row.serial); // Filter out empty rows
          console.log(formattedData)
          resolve(formattedData);
        };
        reader.readAsArrayBuffer(input);
      });
    },
    csvToArray(str, delimiter = ",") {
      const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
      const rows = str.slice(str.indexOf("\n") + 1).split("\n");
      const arr = rows.map(function (row) {
        const values = row.split(delimiter);
        const el = headers.reduce(function (object, header, index) {
          object[header] = values[index];
          return object;
        }, {});
        return el;
      });
      return {
        data: arr,
        headerKeys: headers
      };
    },
    runImportTransferAPI() {
      const updateData = {
        "action": this.action,
        "fromStoreID": this.fromStoreID,
        "toStoreID": this.toStoreID,
        "fromSerial": (this.action == 1 && this.selectedSerialInputType == 2) ? null : this.fromSerial,
        "toSerial": (this.action == 1 && this.selectedSerialInputType == 2) ? null : this.toSerial,
        "listSerial": (this.action == 1 && this.selectedSerialInputType == 2) || this.action == 2 ? this.listSerial : [],
        "force": this.force
      }

      if (this.force == 1) {
        updateData.tid = this.tid;
      }

      useJwt.post('usim', updateData).then(response => {
        if (response.data.code == 400) {
          this.listErrorSim = response.data.result;
          this.ListStatus = response.data.extra.Status || [];
          this.$toast({
            component: ToastificationContent,
            props: {title: response.data.message, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
          this.loading(false);
          this.$bvModal.hide('modal-change');
          this.$bvModal.show('modal-change-error');
          if (this.force == 0) {
            this.tid = this.listErrorSim && this.listErrorSim.length > 0 ? this.listErrorSim[0].ID : null;
            this.force = 1;
          }

          return;
        }
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Cập nhật thành công!', icon: 'CheckSquareIcon', variant: 'success'}
        })
        this.loading(false);
        this.$bvModal.hide('modal-change');
        this.$bvModal.hide('modal-change-error');
      }).catch(error => {
        if (error.response.data.code == 403) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Không có quyền thao tác nghiệp vụ này!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {title: error.response.data.result, icon: 'AlertTriangleIcon', variant: 'warning'}
          })
        }
        this.loading(false);
      })
    },
    async onChangeStoreByFile(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.modalView.validate()

      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        return
      }

      if (this.action == 1) {
        if (this.selectedSerialInputType == 2) {
          this.listSerial = await this.readFile(this.file);
          // const data = this.csvToArray(text);
          // const serialList = data.data.map(item => item[data.headerKeys[1]])
          // const findData = serialList ? serialList.find(item => item != "") : false;
          // if (!findData) {
          //   this.$toast({
          //     component: ToastificationContent,
          //     props: {title: 'Vui lòng kiểm tra dữ liệu file excel!', icon: 'AlertTriangleIcon', variant: 'warning'}
          //   });
          //   return;
          // }
          //
          // this.listSerial = serialList ? serialList : [];


        }
      } else if (this.action == 2) {
        if (this.tableSelectSim.rows && this.tableSelectSim.rows.length == 0) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
          return
        }

        validate = true;
        this.tableSelectSim.rows.forEach(el => {
          if (el.selectFromSerialValid == false && validate) {
            validate = false;
          }
          if (el.selectQuantityValid == false && validate) {
            validate = false;
          }
          if (el.selectToSerialValid == false && validate) {
            validate = false;
          }
        })

        if (!validate) {
          this.$toast({
            component: ToastificationContent,
            props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
          })
          return
        }
        // this.listSerial = []
        // this.tableSelectSim.rows.forEach(el => {
        //   if (el.selectFromSerial && el.selectToSerial && el.selectQuantity) {
        //     for (let i = 0; i < el.selectQuantity; i++) {
        //       // this.listSerial.push(bigInt(el.selectFromSerial).plus(i).toString())
        //     }
        //   }
        // })
      }

      this.runImportTransferAPI()
    },
    getUsimByQuantity(quantity) {
      if (this.fromStoreID == null) {
        return []
      }
      return useJwt.post('usim/range', {fromStoreID: this.fromStoreID, count: quantity}).then(rs => rs.data.result)
    },
    onShowModalChange() {
      this.$bvModal.show('modal-change');
      this.action = 2;
      this.force = 0;
      this.fromStoreID = this.storeList && this.storeList.length ? this.storeList[0].Id : null;
      this.toStoreID = null;
      this.fromSerial = null;
      this.toSerial = null;
      this.file = null;
      this.listSerial = [];
      this.tid = null;
      this.loadSimFromStore()
    },
    onShowModalChangeImport() {
      this.$bvModal.show('modal-change');
      this.action = 1;
      this.force = 0;
      this.fromStoreID = this.storeList && this.storeList.length ? this.storeList[0].Id : null;
      this.toStoreID = null;
      this.fromSerial = null;
      this.toSerial = null;
      this.file = null;
      this.listSerial = [];
      this.tid = null
    },
    onModalImportTransferOpen() {
    },
    onModalImportTransferStoreSelectChange() {
      if (this.toStoreID == this.fromStoreID) {
        this.toStoreID = null
      }
      this.loadSimFromStore()
    },
    onTableSelectSelect(row) {
      row.selectFromSerial = row.storeFromSerial
      row.selectToSerial = row.storeToSerial
      row.selectQuantity = row.storeQuantity
      row.selectFromSerialValid = true
      row.selectToSerialValid = true
      row.selectQuantityValid = true
    },
    onTableSelectDeSelect(row) {
      row.selectFromSerial = null
      row.selectToSerial = null
      row.selectQuantity = null
      row.selectFromSerialValid = true
      row.selectToSerialValid = true
      row.selectQuantityValid = true
    },
    onTableSelectFromInputChange(row) {
      row.selectFromSerialValid = true
      const _row = JSON.parse(JSON.stringify(row))
      _row.selectQuantity = bigInt(row.selectToSerial).minus(row.selectFromSerial).plus(1).toString()
      if (!this.checkValidNumberInRange(_row)) {
        row.selectFromSerialValid = false
        return
      }

      row.selectQuantity = _row.selectQuantity
    },
    onTableSelectToInputChange(row) {
      row.selectToSerialValid = true
      const _row = JSON.parse(JSON.stringify(row))
      _row.selectQuantity = bigInt(row.selectToSerial).minus(row.selectFromSerial).plus(1).toString()
      if (!this.checkValidNumberInRange(_row)) {
        row.selectToSerialValid = false
        return
      }

      row.selectQuantity = _row.selectQuantity
    },
    onTableSelectQuantityInputChange(row) {
      row.selectQuantityValid = true

      const _row = JSON.parse(JSON.stringify(row))
      _row.selectToSerial = bigInt(_row.selectFromSerial).plus(_row.selectQuantity).minus(1).toString()

      if (!this.checkValidNumberInRange(_row)) {
        row.selectQuantityValid = false
        return
      }
      row.selectToSerial = _row.selectToSerial
    },
    checkValidNumberInRange(row) {
      const d1 = !bigInt(row.selectFromSerial).lesser(row.storeFromSerial)
      const d2 = !bigInt(row.selectFromSerial).greater(row.storeToSerial)
      const d3 = !bigInt(row.selectToSerial).lesser(row.storeFromSerial)
      const d4 = !bigInt(row.selectToSerial).greater(row.storeToSerial)
      const d5 = bigInt(row.selectToSerial).minus(bigInt(row.selectFromSerial).plus(1).toString()).toString() <= row.storeQuantity

      return d1 && d2 && d3 && d4 && d5
    },
    onCheckSim(value, row, idx) {
      if (value) {
        this.onTableSelectSelect(row, idx)
      } else {
        this.onTableSelectDeSelect(row, idx)
      }
    }
  },
  data() {
    return {
      action: 1,
      fromStoreID: 0,
      toStoreID: 0,
      fromSerial: null,
      toSerial: null,
      simQuantity: 1,
      listSerial: [],
      force: 0,
      product: 'usim',
      file: null,
      listErrorSim: [],
      isEditPhoneEmail: false,
      searchString: "",
      isLoading: false,
      totalRecords: 0,
      rows: [],
      //dkttRows:[],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchTerm: '',
      currentItem: {},
      Cities: [],
      Districts: [],
      Wards: [],
      ListStatus: [],
      fieldsError: [
        {
          field: 'Serial',
          filterOptions: {enabled: true, placeholder: ''},
          label: 'Serial SIM',
        },
        {
          field: 'Status',
          filterOptions: {enabled: true, placeholder: ''},
          label: 'Status',
        }
      ],
      fields: [
        {
          field: 'CreateDate',
          filterOptions: {enabled: true, placeholder: ''},
          label: 'Ngày nhập SIM',
        },
        {
          field: 'Serial',
          filterOptions: {enabled: true, placeholder: ''},
          label: 'Serial SIM',
        },
        {
          field: 'ProductName',
          filterOptions: {enabled: true, placeholder: ''},
          label: 'Loại hàng',
        },
        {
          field: 'IsEsim',
          filterOptions: {enabled: true, placeholder: ''},
          label: 'Loại sim',
        },
        // {
        //   field: 'Status',
        //   filterOptions: {enabled: true, placeholder: ''},
        //   label: 'Trạng thái',
        // },
        {
          field: 'StoreID',
          filterOptions: {enabled: true, placeholder: ''},
          label: 'Kho',
        },
        {field: 'action', label: 'Actions', width: '100px'}
      ],
      tableSelectSim: {
        columns: [
          {
            field: 'stt',
            label: 'STT'
          },
          {
            field: 'storeFromSerial',
            label: 'Từ số'
          },
          {
            field: 'storeToSerial',
            label: 'Đến số'
          },
          {
            field: 'selectFromSerial',
            label: 'Từ số'
          },
          {
            field: 'selectToSerial',
            label: 'Đến số'
          },
        ],
        rows: []
      },
      statusList: [],
      storeList: [],
      storeToList: [],
      vnPayErrors: [
        {id: "00", text: "Giao dịch thành công"},
        {id: "07", text: "Trừ tiền thành công. Giao dịch bị nghi ngờ (liên quan tới lừa đảo, giao dịch bất thường)."},
        {
          id: "09",
          text: "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng chưa đăng ký dịch vụ InternetBanking tại ngân hàng."
        },
        {
          id: "10",
          text: "Giao dịch không thành công do: Khách hàng xác thực thông tin thẻ/tài khoản không đúng quá 3 lần"
        },
        {
          id: "11",
          text: "Giao dịch không thành công do: Đã hết hạn chờ thanh toán. Xin quý khách vui lòng thực hiện lại giao dịch."
        },
        {id: "12", text: "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng bị khóa."},
        {
          id: "13",
          text: "Giao dịch không thành công do Quý khách nhập sai mật khẩu xác thực giao dịch (OTP). Xin quý khách vui lòng thực hiện lại giao dịch."
        },
        {id: "24", text: "Giao dịch không thành công do: Khách hàng hủy giao dịch"},
        {
          id: "51",
          text: "Giao dịch không thành công do: Tài khoản của quý khách không đủ số dư để thực hiện giao dịch."
        },
        {
          id: "65",
          text: "Giao dịch không thành công do: Tài khoản của Quý khách đã vượt quá hạn mức giao dịch trong ngày."
        },
        {id: "75", text: "Ngân hàng thanh toán đang bảo trì."},
        {
          id: "79",
          text: "Giao dịch không thành công do: KH nhập sai mật khẩu thanh toán quá số lần quy định. Xin quý khách vui lòng thực hiện lại giao dịch"
        },
        {id: "99", text: "Lỗi thanh toán ngân hàng, quý khách vui lòng thử lại"},
      ],
      ghtkStatus: [
        {id: '-1', text: 'Hủy đơn hàng'},
        {id: '1', text: 'Chưa tiếp nhận'},
        {id: '2', text: 'Đã tiếp nhận'},
        {id: '3', text: 'Đã lấy hàng/Đã nhập kho'},
        {id: '4', text: 'Đã điều phối giao hàng/Đang giao hàng'},
        {id: '5', text: 'Đã giao hàng/Chưa đối soát'},
        {id: '6', text: 'Đã đối soát'},
        {id: '7', text: 'Không lấy được hàng'},
        {id: '8', text: 'Hoãn lấy hàng'},
        {id: '9', text: 'Không giao được hàng'},
        {id: '10', text: 'Delay giao hàng'},
        {id: '11', text: 'Đã đối soát công nợ trả hàng'},
        {id: '12', text: 'Đã điều phối lấy hàng/Đang lấy hàng'},
        {id: '13', text: 'Đơn hàng bồi hoàn'},
        {id: '20', text: 'Đang trả hàng (COD cầm hàng đi trả)'},
        {id: '21', text: 'Đã trả hàng (COD đã trả xong hàng)'},
        {id: '123', text: 'Shipper báo đã lấy hàng'},
        {id: '127', text: 'Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng'},
        {id: '128', text: 'Shipper báo delay lấy hàng'},
        {id: '45', text: 'Shipper báo đã giao hàng'},
        {id: '49', text: 'Shipper báo không giao được giao hàng'},
        {id: '410', text: 'Shipper báo delay giao hàng'},
      ],
      serverParams: {
        "columnFilters": {},
        "page": 1,
        "pageSize": 50,
        "sort": []
      },
      required,
      selectedSerialInputType: 2,
      optionsSerialInputType: [
        // {text: 'Dải', value: 1},
        {text: 'File', value: 2}
      ],
      optionsSerialInputTypeTransfer: [
        {text: 'Dải', value: 1},
        {text: 'Số lượng', value: 2}
      ],
      tid: null,
      filterValue: {
        storeId: '',
        statusId: ''
      }
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style scoped>
.position-relative {
  position: relative;
}

.clear-button {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.error-txt small {
  color: red;
}

.pt-2-5 {
  padding-top: 2rem !important;
}

.fz-14 {
  font-size: 14px;
}

.b2c-order .vgt-wrap {
  max-height: calc(100vh - 300px);
  overflow: auto;
}

.font-small .table-sm {
  font-size: 11px;
}

.col-gap-1 {
  column-gap: 1rem
}

.c-table {
  width: 100%;
}

.c-table th, td {
  border: 1px solid #cbcbcb;
  text-align: center;
  padding: 3px;
}

.c-table .error-ico {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  color: red;
}

.c-table .c-form-group {
  position: relative;
}

.sample-file__download {
  padding: 5px 10px;
  border-radius: 6px;
  border: 2px solid #f07577;
  font-weight: bold;
  cursor: pointer;
  width: fit-content;
  font-size: 0.857rem;
  display: flex;
  align-items: center;
  width: 120px;
  color: rgb(37, 37, 37) !important;
}

.sample-file__download:hover {
  background-color: #ececec77;
}

.center-cls {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
